import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import AlertList from 'src/components/ProductDetails/types/AlertList';
import AlertSegment from 'src/components/ProductDetails/types/AlertSegment';
import { getAlerts } from 'src/components/ProductDetails/api/alerts.api';

export type AlertListState = FetchState<AlertSegment[]>;

type UseAlertListFetchProps = {
  emailId: string;
  matchType: string;
  regionId: string;
  sourceProductId: string;
};

const initialState: AlertListState = {
  loading: false,
  error: false,
  data: null,
};

const useAlertListFetch = ({
  emailId,
  matchType,
  regionId,
  sourceProductId,
}: UseAlertListFetchProps): [AlertListState] => {
  const params: AlertList.Request = {
    email: emailId,
    matchType,
    regionId,
    sourceProductId,
  };
  const [{ loading, data, error }] = useFetchReducer(
    () => getAlerts(params),
    [emailId, matchType, regionId, sourceProductId]
  );
  const state: AlertListState = { ...initialState, loading, error };

  if (!data) {
    return [state];
  }

  return [
    {
      ...state,
      data,
    },
  ];
};

export default useAlertListFetch;
